import type { SystemProps } from '@xstyled/styled-components'
import type { DotProps } from './AudioWaveform.styles'
import { Dot, StyledWaveform } from './AudioWaveform.styles'
import { useAudioWaveform } from './useAudioWaveform'

export interface AudioWaveformProps extends DotProps {
  data: number[]
  numberOfBars: number
  width?: SystemProps['w']
}

export function AudioWaveform(props: AudioWaveformProps) {
  const waveform = useAudioWaveform(props)

  return (
    <StyledWaveform w={props.width}>
      {waveform.state.map((data, index) =>
        data === 255 ? null : (
          <Dot
            size={props.size}
            key={index}
            variant={props.variant}
            style={{
              height: waveform.getHeight(data)
            }}
          />
        )
      )}
    </StyledWaveform>
  )
}
